// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d5fbeb84","732":"3074f8e6","977":"410184e8"}[chunkId] + ".chunk.js";
};